import styled from 'styled-components'

export const StyledList = styled.ul`
  max-height: 200px; /* example height */
  overflow-y: auto;
  position: absolute;
  background-color: whitesmoke;
  &::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    background-color: #f2f2f2; /* example background color */
    border-radius: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #005cdb; /* example thumb color */
    border-radius: 5px;
  }
`

export const StyledListItem = styled.li`
  cursor: pointer;
  &:hover {
    background-color: grey;
    color: white;
  }
`
